<div
  leaflet
  [leafletOptions]="options"
  [leafletFitBounds]="fitBoundsOptions"
  [leafletMarkerCluster]="markerClusterData"
  (leafletMarkerClusterReady)="markerClusterReady($event)"
></div>
